export default __webpack_public_path__ + "static/media/vip-icon-active.180169f0.webp";